module.exports = __webpack_public_path__ + "img/posx.d28d8900.jpg";